import axios from 'axios';
import Settings from './config';

export default {

   

    getAddressBooks(emailAddress, cb) {

        axios.get(Settings.ENDPOINT + 'api/marketing/address-books?emailAddress=' + emailAddress)
            .then(response => {
                cb(response.data);
            });
    },
    subscribe(payload, cb) {

        axios.post(Settings.ENDPOINT + 'api/marketing/subscribe', payload)
            .then(response => {
                cb(response.data);
            });
    },
    unsubscribe(payload, cb) {

        axios.post(Settings.ENDPOINT + 'api/marketing/unsubscribe', payload)
            .then(response => {
                cb(response.data);
            });
    }
}